module.exports = " <div class=\"asset-tile is-folder\" @click.prevent=selectFolder(folder.path)> <div class=asset-thumb-container> <file-icon extension=folder></file-icon> </div> <div class=asset-meta> <div class=asset-filename :title=label>{{ folder.title }}</div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/assets/Browser/Listing/FolderTile.vue
// module id = 269
// module chunks = 0